import { FC, PropsWithChildren } from 'react';
import { IndicatorBaseProps } from './baseIndicator';
import Style from './baseIndicator.module.scss';
import { Tooltip } from '../uikit/tooltip/tooltip.component';
import clsx from 'clsx';

export const BaseIndicatorWrapper: FC<PropsWithChildren<IndicatorBaseProps>> = (props) => {
  return (
    <Tooltip
      styles={Style.base}
      tooltipContent={
        <TooltipContent
          tooltipText={props.tooltipText}
          headerText={props.headerText}
          bottomElement={props.bottomElement}
          textStyle={props.textStyle}
        />
      }
    >
      <div data-test-id={`indicator-${props.testId}`} className={clsx({ [Style.container]: true, [Style.base]: true })}>
        {props.children}
      </div>
    </Tooltip>
  );
};

const TooltipContent: FC<Pick<IndicatorBaseProps, 'headerText' | 'tooltipText' | 'bottomElement' | 'textStyle'>> = ({
  headerText,
  tooltipText,
  bottomElement,
  textStyle,
}) => (
  <div className={Style.tooltipContent}>
    <div>
      {headerText && (
        <p data-test-id={'common-tooltip-header'} className={Style.header}>
          {headerText}
        </p>
      )}
      <p
        data-test-id={'common-tooltip-text'}
        className={clsx(Style.text, textStyle, { [Style.withHeader]: !!headerText })}
      >
        {tooltipText}
      </p>
    </div>
    {bottomElement}
  </div>
);
